import { NavLink, Outlet } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { SETTINGS_ITEMS, stepLabel } from "@/constants/settingsItems";

export default function Settings() {
  return (
    <div className="min-h-full bg-white px-8 py-8" data-testid="settings-page">
      <h1 className="text-3xl font-bold text-[#1e2d38] mb-6">Settings</h1>

      {/* Setting sections nav */}
      <nav
        className="flex flex-wrap gap-x-6 gap-y-4 border-b border-slate-200 pb-5 mb-8"
        data-testid="settings-nav"
      >
        {SETTINGS_ITEMS.map((item, i) => (
          <NavLink
            key={item.slug}
            to={`/settings/${item.slug}`}
            data-testid={`settings-tab-${item.slug}`}
            className={({ isActive }) =>
              `group flex flex-col leading-tight transition-colors ${
                isActive ? "text-[#13B5EA]" : "text-slate-500 hover:text-[#13B5EA]"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <span className="flex items-center gap-1">
                  <span className="text-xs font-bold underline underline-offset-2">
                    {stepLabel(i)}
                  </span>
                  {item.caret && <ChevronDown size={13} className="mt-0.5" />}
                </span>
                <span className="text-sm italic mt-0.5">{item.label}</span>
                <span
                  className={`mt-1 h-0.5 rounded-full bg-[#13B5EA] transition-all ${
                    isActive ? "w-full opacity-100" : "w-0 opacity-0 group-hover:w-full group-hover:opacity-40"
                  }`}
                />
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
